import {
  Grid2 as Grid,
  TextField,
  Typography,
  Box,
  Card,
  Divider,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { FaSignature } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";

import { counties } from "../../../../data/dbpr";

const RenderNocFormFields = ({
  currentProcessingFile,
  setCurrentProcessingFile,
  selectedContractor,
  setSelectedContractor,
  contractors,
  setContractors,
}) => {
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const currentSession = useSelector((state) => state.sessions.currentSession);
  const currentUser = useSelector((state) => state[currentSession]?.user);
  const dispatch = useDispatch();

  const toTitleCase = (str) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) =>
        word
          .split("-")
          .map(
            (part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
          )
          .join("-")
      )
      .join(" ");

  useEffect(() => {
    if (!currentUser?.user?.contractors) return;

    const updatedContractors = currentUser.user.contractors.map(
      (contractor, i) => ({
        id: i,
        intern: true,
        first_name: contractor?.firstName,
        middle_name: contractor?.middleName,
        last_name: contractor?.lastName,
        company_name: contractor?.businessName,
        email: contractor?.email,
        phone_number: contractor?.mobile,
        address: contractor?.mainAddress,
        licenseNumber: contractor?.licenseNumber,
      })
    );

    setContractors([
      ...updatedContractors,
      {
        id: 9999,
        intern: false,
        first_name: "",
        middle_name: "",
        last_name: "",
        company_name: "",
        email: "",
        phone_number: "",
        address: "",
        licenseNumber: "other",
      },
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  const renderSection = ({
    name,
    title,
    data,
    color,
    type,
    showContractorBtn = false,
  }) => (
    <Box sx={{ mt: 2 }}>
      <Box
        sx={{
          minHeight: 40,
          backgroundColor: color,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          px: 2,
          py: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: 1,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FaSignature color="white" />
          <Typography sx={{ color: "white", fontWeight: "bold", fontSize: 14 }}>
            {data?.label || title}
          </Typography>
        </Box>
        {name === "owner" && (
          <Box>
            <Typography
              sx={{ color: "#fff", fontWeight: "bold" }}
              variant="body2"
            >
              Project Address:{" "}
              {currentProcessingFile?.document_location?.project_address ||
                "N/A"}
            </Typography>
          </Box>
        )}
        {showContractorBtn ? (
          <>
            <FormControl
              sx={{
                minWidth: mobileSize ? "100%" : 320,

                "& .MuiFilledInput-root": {
                  backgroundColor: "transparent",
                  border: "1px solid #fff",
                  boxShadow: "none !important",
                },
                "& .MuiInputLabel-root": {
                  color: "#fff",
                  "&.Mui-focused": {
                    color: "#fff",
                    boxShadow: "none !important",
                    outline: "none !important",
                  },
                },
                "& .MuiSelect-select": {
                  color: "#fff",
                  boxShadow: "none !important",
                  outline: "none !important",
                },
              }}
              variant="filled"
            >
              <InputLabel sx={{ color: "#fff" }} id="licenseType-label">
                {selectedContractor?.company_name
                  ? selectedContractor.company_name
                  : selectedContractor?.first_name &&
                    selectedContractor?.last_name
                  ? `${selectedContractor.first_name} ${selectedContractor.last_name}`
                  : "Select Contractor"}
              </InputLabel>
              <Select
                disableUnderline
                displayEmpty
                size="small"
                name="licenseType"
                label="License Type"
                value={selectedContractor?.id ?? ""}
                renderValue={(selectedValue) => {
                  if (selectedValue === null || selectedValue === undefined)
                    return;

                  if (Object.keys(selectedContractor).length === 0) {
                    return;
                  }

                  if (selectedContractor?.licenseNumber === "other") {
                    return "Unknown License";
                  }
                  if (!selectedContractor?.licenseNumber) {
                    return "Unknown License";
                  } else {
                    return selectedContractor?.licenseNumber;
                  }
                }}
                sx={{
                  "&.Mui-focused": {
                    boxShadow: "none !important",
                    border: "1px solid #fff",
                  },
                  "& .MuiTypography-body2": {
                    whiteSpace: "wrap",
                  },
                  "& .MuiSelect-icon": {
                    color: "#fff !important", // arrow always white
                  },
                }}
                onChange={(e) => {
                  const selectedId = e.target.value;

                  const selected = contractors.find((c) => c.id === selectedId);

                  if (
                    Object.keys(selectedContractor).length === 0 &&
                    selectedId === 9999
                  ) {
                    const formatted = {
                      id: 9999,
                      intern: false,
                      first_name:
                        currentProcessingFile?.contractor?.PERSON?.first_name ||
                        "",
                      middle_name:
                        currentProcessingFile?.contractor?.PERSON
                          ?.middle_name || "",
                      last_name:
                        currentProcessingFile?.contractor?.PERSON?.last_name ||
                        "",
                      company_name:
                        currentProcessingFile?.contractor?.ORGANIZATION
                          ?.nameUnparsed || "",
                      email: currentProcessingFile?.contractor?.email || "",
                      phone_number:
                        currentProcessingFile?.contractor?.phone_number || "",
                      address: currentProcessingFile?.contractor?.address || "",
                      licenseNumber: "", // ⬅️ field should be EMPTY
                    };
                    setSelectedContractor(formatted);

                    dispatch({
                      type: "SET_CUSTOM_CREATE_NOC_CONTRACTOR",
                      payload: {
                        ...currentProcessingFile.contractor,
                        licenseNumber: "",
                      },
                    });

                    setCurrentProcessingFile((prev) => ({
                      ...prev,
                      contractor: {
                        ...prev?.contractor,
                        licenseNumber: "",
                      },
                    }));
                  } else {
                    setSelectedContractor(selected);

                    const formatted = {
                      id: selected.id,
                      intern: selected?.intern,
                      address: selected?.address || "",
                      phone_number: selected?.phone_number || "",
                      email: selected?.email || "",
                      licenseNumber: selected?.licenseNumber || "",
                      PERSON: {
                        first_name: selected?.first_name || "",
                        middle_name: selected?.middle_name || "",
                        last_name: selected?.last_name || "",
                        business_name: selected?.company_name || "",
                      },
                      ORGANIZATION: {
                        nameUnparsed: selected?.company_name || "",
                      },
                    };

                    dispatch({
                      type: "SET_CUSTOM_CREATE_NOC_CONTRACTOR",
                      payload: formatted,
                    });

                    setCurrentProcessingFile((prev) => ({
                      ...prev,
                      contractor: formatted,
                    }));
                  }
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      marginTop: "1.5px",
                      maxHeight: 150,
                      width: "auto",
                      maxWidth: "100%",
                      backgroundColor: "#333",
                      color: "#fff",
                    },
                  },
                  MenuListProps: {
                    sx: {
                      "& .MuiMenuItem-root": {
                        "&:hover": {
                          backgroundColor: "#444", // lighter than #333
                        },
                      },
                    },
                  },
                }}
              >
                {contractors.map((contractor, i) => (
                  <MenuItem key={i} value={contractor.id}>
                    <Typography variant="body2">
                      {contractor.id === 9999
                        ? "Other"
                        : `${contractor.company_name || "Unknown"} - ${
                            contractor.licenseNumber
                          }`}
                    </Typography>
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        ) : (
          <></>
        )}
      </Box>

      <Divider sx={{ mb: 2 }} />

      {/* IF RECORD ONLY --> No OWNER EMAIL, NO OWNER PHONE */}
      <Grid container spacing={2}>
        {[
          { label: "First Name", key: "first_name", nested: "PERSON" },
          { label: "Middle Name", key: "middle_name", nested: "PERSON" },
          { label: "Last Name", key: "last_name", nested: "PERSON" },
          {
            label: "Organization Name",
            key: "nameUnparsed",
            nested: "ORGANIZATION",
          },
          { label: "Email", key: "email" },
          { label: "Phone Number", key: "phone_number" },
          // { label: "Main Address", key: "address" },
          // { label: "Project Address", key: "project_address" },
          { label: "License Number", key: "licenseNumber" },
          { label: "County", key: "county" },
        ]
          .filter((item) => {
            if (
              currentProcessingFile?.document?.actions?.record &&
              !currentProcessingFile?.document?.actions?.notarize &&
              name === "owner" &&
              ["email", "phone_number"].includes(item.key)
            ) {
              return false;
            }
            return true;
          })
          .map(({ label, key, nested }) => {
            if (name !== "contractor" && key === "licenseNumber") {
              return <React.Fragment key={key} />;
            }

            if (
              name !== "owner" &&
              ["project_address", "county"].includes(key)
            ) {
              return <React.Fragment key={key} />;
            }

            let fieldValue = nested
              ? data?.[nested]?.[key] || ""
              : data?.[key] || "";

            if (key === "licenseNumber" && selectedContractor?.id === 9999) {
              fieldValue = fieldValue === "other" ? "" : fieldValue;
            }

            const isEmail = key === "email";
            const isPhone = key === "phone_number";

            let isEmailValid = true;
            let isPhoneValid = true;

            if (
              name === "owner" &&
              currentProcessingFile?.document?.actions?.record &&
              !currentProcessingFile?.document?.actions?.notarize
            ) {
              isEmailValid = true;
              isPhoneValid = true;
            } else {
              isEmailValid =
                !isEmail ||
                /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue) ||
                fieldValue === "";

              isPhoneValid =
                !isPhone || fieldValue.length === 12 || fieldValue === "";
            }

            if (key === "project_address") {
              fieldValue =
                currentProcessingFile?.document_location?.project_address;
            }

            if (key === "county" && name === "owner") {
              fieldValue = (
                currentProcessingFile?.document_location?.county || ""
              )
                .toUpperCase()
                .trim();
            }

            return (
              <Grid
                size={{
                  xs: 12,
                  sm: 6,
                }}
                key={key}
              >
                {key === "county" ? (
                  <FormControl fullWidth variant="filled">
                    <InputLabel id="licenseType-label">
                      Project Address County
                    </InputLabel>
                    <Select
                      label="County"
                      value={fieldValue}
                      onChange={(e) => {
                        const value = toTitleCase(e.target.value);

                        dispatch({
                          type: "UPDATE_CUSTOM_CREATE_NOC_COUNTY",
                          payload: value,
                        });

                        setCurrentProcessingFile((prev) => ({
                          ...prev,
                          document_location: {
                            ...prev?.document_location,
                            county: value,
                          },
                        }));
                      }}
                      MenuProps={{
                        PaperProps: {
                          sx: {
                            marginTop: "1.5px",
                            maxHeight: 280, // Set the desired max height for the dropdown menu
                            width: "auto",
                            maxWidth: "100%",
                            "&& .Mui-selected": {
                              backgroundColor: "#E2E3E5",
                            },
                          },
                        },
                      }}
                      sx={{
                        maxWidth: "100%", // Set the desired max-width for the input element
                        "& .MuiTypography-body2": {
                          whiteSpace: "wrap", // Prevent text from wrapping or shrinking
                        },
                      }}
                    >
                      {counties
                        .filter(
                          (county) =>
                            ![
                              "ALL",
                              "NONE",
                              "UNKNOWN",
                              "OUT OF STATE",
                            ].includes(county?.toUpperCase?.())
                        )
                        .map((county, i) => (
                          <MenuItem key={i} value={county}>
                            <Typography variant="body2">{county}</Typography>
                          </MenuItem>
                        ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    disabled={
                      name === "contractor" &&
                      (Object.keys(selectedContractor).length === 0 ||
                        selectedContractor?.intern)
                    }
                    fullWidth
                    variant="filled"
                    label={label}
                    value={fieldValue}
                    error={
                      (isEmail && !isEmailValid) || (isPhone && !isPhoneValid)
                    }
                    helperText={
                      isEmail && !isEmailValid
                        ? "Enter a valid email"
                        : isPhone && !isPhoneValid
                        ? "Enter a complete 10-digit phone number"
                        : ""
                    }
                    onChange={(e) => {
                      let value = e.target.value;

                      if (isPhone) {
                        const digitsOnly = value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        value = "";
                        for (let i = 0; i < digitsOnly.length; i++) {
                          if (i === 3 || i === 6) {
                            value += "-";
                          }
                          value += digitsOnly[i];
                        }
                      }

                      let project_address = undefined;

                      if (name === "owner" && key === "project_address") {
                        project_address = value;

                        dispatch({
                          type: "UPDATE_CUSTOM_CREATE_NOC_PROJECT_ADDRESS",
                          payload: value,
                        });
                      }

                      dispatch({
                        type: "UPDATE_CUSTOM_CREATE_NOC",
                        payload: {
                          type, // "signer" or "contractor"
                          nested, // "PERSON" or "ORGANIZATION"
                          key, // "first_name", etc.
                          value, // formatted/validated value
                        },
                      });

                      setCurrentProcessingFile((prev) => {
                        const updated = {
                          ...prev,
                          [type]: {
                            ...prev?.[type],
                            ...(nested
                              ? {
                                  [nested]: {
                                    ...prev?.[type]?.[nested],
                                    [key]: value,
                                  },
                                }
                              : { [key]: value }),
                          },
                        };

                        if (project_address !== undefined) {
                          updated.document_location = {
                            ...prev?.document_location,
                            project_address,
                          };
                        }

                        return updated;
                      });

                      if (name === "contractor") {
                        let update = {};

                        if (key === "nameUnparsed") {
                          update = { company_name: value };
                        } else {
                          update = { [key]: value };
                        }

                        setSelectedContractor((prev) => ({
                          ...prev,
                          ...update,
                        }));
                      }
                    }}
                  />
                )}
              </Grid>
            );
          })}
      </Grid>
    </Box>
  );

  const { document, signer, contractor } = currentProcessingFile || {};
  const actions = document?.actions || {};

  return (
    <Card
      variant="outlined"
      sx={{
        p: 2,
        borderRadius: 2,
        mb: 2,
        boxShadow: "3px 5px 6px 4px rgba(0, 0, 0, 0.2) !important",
      }}
    >
      <Typography
        align="center"
        color="primary"
        variant="h5"
        fontSize={mobileSize ? "1rem" : "1.5rem"}
      >
        Please complete the required fields before we can begin processing your
        document
      </Typography>
      {actions?.notarize || actions?.record ? (
        renderSection({
          name: "owner",
          title: "Signer - Grantor",
          data: signer,
          color: "RGBA(60, 145, 80, 0.6)",
          type: "signer",
        })
      ) : (
        <></>
      )}

      {actions?.record &&
        renderSection({
          name: "contractor",
          title: "Contractor - Grantee",
          data: contractor,
          color: "RGBA(175, 60, 60, 0.6)",
          type: "contractor",
          showContractorBtn: true,
        })}
    </Card>
  );
};

export default RenderNocFormFields;
